import React from "react";

const CreditCardSecurity: React.FC = () => {
  return (
    <div>
      <h2>Sigurnost plaćanja kreditnim karticama</h2>
      <p>
        Tajnost Vaših podataka je zaštićena i osigurana korištenjem posljednje
        verzije TLS enkripcije. Stranice za naplatu putem interneta osigurane su
        korištenjem Secure Socket Layer (SSL) protokola sa 128-bitnom
        enkripcijom podataka. SSL enkripcija je postupak šifriranja podataka
        radi sprječavanja neovlaštenog pristupa prilikom njihovog prijenosa.
      </p>
      <p>
        Time je omogućen siguran prijenos informacija te onemogućen nedozvoljen
        pristup podacima prilikom komunikacije između korisnikovog računala i
        WebPay servisa, te obratno.
      </p>
      <p>
        WebPay servis i financijske ustanove razmjenjuju podatke uporabom
        virtualne privatne mreže (VPN), koja je zaštićena od neautoriziranog
        pristupa.
      </p>
      <p>
        Monri Payment Gateway je certificiran prema PCI DSS Level 1 sigurnosnom
        standardu propisanom Visa i Mastercard pravilima.
      </p>
      <p>
        Trgovac ne pohranjuje brojeve kreditnih kartica i brojevi nisu dostupni
        neovlaštenim osobama.
      </p>
    </div>
  );
};

export default CreditCardSecurity;
